import { Location, Specialty } from './types';

const getParamFromUrl = (paramName: string): string | null => {
  return new URLSearchParams(window.location.search).get(paramName);
};

export const getAvailabilityParams = (
  appointmentTypeId: string | null,
  specialty: Specialty | null
): { appointmentTypeId: string } | { specialty: Specialty; locationType: Location } => {
  if (!appointmentTypeId && !specialty) {
    throw new Error(
      'Cannot pull monthly availability. Either appointment type ID or specialty is required'
    );
  }

  if (appointmentTypeId) {
    return { appointmentTypeId };
  }

  return { specialty: specialty!, locationType: Location.Online };
};

export const getSpecialtyParamFromUrl = (): Specialty | null => {
  const specialtyParamAsUpperCase = getParamFromUrl('specialty')?.toUpperCase();

  return (
    (specialtyParamAsUpperCase &&
      [Specialty.Exercise, Specialty.Medical, Specialty.Metabolism, Specialty.Nutritional].find(
        (specialty) => specialty === specialtyParamAsUpperCase
      )) ||
    null
  );
};

export const getAppointmentTypeIdParamFromUrl = (): string | null => {
  return getParamFromUrl('appointmentTypeId');
};

export const getCalendarIdParamFromUrl = (): string | null => {
  return getParamFromUrl('calendarId');
};

export const getCoreAppointmentIdFromUrl = (): string | null => {
  return getParamFromUrl('existingCoreAppointmentId');
};
